document.addEventListener('DOMContentLoaded', () => {

    // let imagesSliders = document.querySelectorAll('.images-sliders');
    // if(imagesSliders){
    //     imagesSliders.forEach((item)=>{
    //         new Swiper('.images-sliders', {
    //             loop: true,
    //             effect: "fade",
    //             fadeEffect: {
    //                 "crossFade": true
    //             },
    //             navigation: {
    //                 nextEl: `.sw-but-img-next`,
    //                 prevEl: `.sw-but-img-prev`,
    //             },
    //         });
    //     });
    // }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                },
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper('.slider-slide', {
                rewind: true,
                effect: "fade",
                autoHeight: true,
                speed: 800,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let sliderTwoImagesSlide = document.querySelectorAll('.slider-two-images-slide');
    if(sliderTwoImagesSlide){
        sliderTwoImagesSlide.forEach((item)=> {
            new Swiper('.slider-two-images-slide', {
                rewind: true,
                effect: "fade",
                autoHeight: true,
                speed: 800,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let sliderOvSlide = document.querySelectorAll('.slider-ov-slide');
    if(sliderOvSlide){
        sliderOvSlide.forEach((item)=> {
            new Swiper('.slider-ov-slide', {
                watchSlidesProgress: true,
                slidesPerView: 1,
                loop: true,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-slider-next",
                    prevEl: ".sw-slider-prev",
                },
                breakpoints: {
                    840: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 2,
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                watchSlidesProgress: true,
                slidesPerView: 1,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                    },
                },
            });
        });
    }

    let galleryGrid = document.querySelectorAll('.gallery-grid');
    if(galleryGrid){
        galleryGrid.forEach((item)=> {
            new Swiper('.gallery-grid', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }
    
    let sliderTwo = document.querySelectorAll('.slider-two');
    if (sliderTwo) {
        sliderTwo.forEach((slider) => {
            const swiperContainer = slider.querySelector('.slider-two-swiper');
            const prevButton = slider.querySelector(".sw-but-prev");
            const nextButton = slider.querySelector(".sw-but-next");
    
            const swiperOptions = {
                slidesPerView: 'auto',
                loop: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton, 
                }
            };
    
            // Duplicate items to ensure continuous loop
            const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
            const originalSlides = Array.from(swiperWrapper.querySelectorAll('.item'));
            originalSlides.forEach((slide) => {
                const clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            });
    
            new Swiper(swiperContainer, swiperOptions);
        });
    }


    let highlightSwiper = document.querySelectorAll('.highlights-swiper');
    if(highlightSwiper){
        highlightSwiper.forEach((item)=> {
            new Swiper('.highlights-swiper', {
                loop: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

});